import { get, isEmpty } from 'lodash';
import { gamification } from '../api/event';

export const parseQueryParams = (searchParams) => {
  if (isEmpty(searchParams)) {
    return {};
  }
  const splitParams = searchParams.split('?');
  const parsedInfo = {};
  if (splitParams.length > 1) {
    const [, queryParams] = splitParams;
    queryParams.split('&').forEach((item) => {
      const [key, value] = item.split('=');
      parsedInfo[key] = value;
    });
  }
  return parsedInfo;
};

export const parseJwt = (token) => {
  try {
    return JSON.parse(atob(token.split('.')[1]));
  } catch (e) {
    return null;
  }
};
export const redirectTo = (pathname) => {
  history.pushState('', '', pathname);
  window.dispatchEvent(new PopStateEvent('popstate'));
};

export const arrayIncludes = (array, value) =>
  array.some((element) => element.toLowerCase() === value.toLowerCase());
